import React, { useContext, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';

import { Box, Button, Stack } from "@mui/material";

import Label from "../../../../common/components/Label";
import { COLOR_MAP } from "../../../../constants/ColorNames";
import TextBox from "../../../../common/components/Textbox";
import styled from "@emotion/styled";
import { SWITCH_ICON } from "../../../../constants/icons/SwitchIcon";
import { setSenderId, setReplyId, setErrorMessages, setDisableBlast } from "../../../../redux/slice/campaignSlice";
import { useGetEmailVerifiedQuery } from "../../../../redux/services/folderName";
import { RootState } from "../../../../redux/store";
import { ToastContext } from "../../../../utils/context/toastContext";
import { Gmail } from "../../../../constants/icons/Gmail";
import { getFounditDomain } from "../../../../utils/helpers";
import { INFO_ICON } from "../../../../constants/icons/InfoIcon";
import CommonTooltip from "../../../../common/components/CommonTooltip";

const SwitchEmail = styled.p`
    font-weight:600 ;
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: ${COLOR_MAP.DARK_PURPLE};
    margin: 0;
    cursor: pointer;
`
const StyledReplyToStack = styled(Stack)`
  
`

const SenderDetails = () => {
    const dispatch = useDispatch();
    const [disableReplyId, setDisableReplyId] = React.useState(false);
    const { data: emailVerifiedData, refetch: triggerEmailRefetch} = useGetEmailVerifiedQuery(1);
    const senderId = useSelector((state: RootState) => state.campaign.senderId);
    const companyReplyId = useSelector((state: RootState) => state.campaign.companyReplyId);
    const replyId = useSelector((state: RootState) => state.campaign.replyId);
    const errorMessages = useSelector((state: RootState) => state.campaign.errorMessages);
    const outreachType = useSelector((state: RootState) => state.campaign.outreachType);
    const { setToastValue } = useContext(ToastContext);
    const [senderEmail , setSenderEmail]= React.useState(senderId);
    const [hideSwitch, setHideSwitch] = React.useState(false)
    const [isGmailUser, setIsGmailUser] = React.useState(false);

    let url = window.location.hostname;

// setting the domain name for other channels only to display in ui.
    React.useEffect(() => {
      if(url && !url.includes('in')){
        let domain =  getFounditDomain(url);
        setSenderEmail( `opportunities@${domain}`);
      }
    },[url])

// initially check if email is verified then replace it.
    React.useEffect(() => {
      if(outreachType === 'BLAST' && !senderEmail.includes('opportunities')){
        let domain =  getFounditDomain(url);
        setSenderEmail( `opportunities@${domain}`);
        dispatch(setSenderId({ senderId: 'opportunities@foundit.in' })); 
        setDisableReplyId(false);
      }
      else if( emailVerifiedData ) {
          if(emailVerifiedData?.email){
            dispatch(setSenderId({ senderId: emailVerifiedData.email })); 
            setSenderEmail(emailVerifiedData.email);
            dispatch(setReplyId({ replyId: emailVerifiedData.email}));
            setDisableReplyId(true);
            setIsGmailUser(emailVerifiedData.isGmail);
          } else {
            if(!emailVerifiedData?.redirectURL) {
              setHideSwitch(true)
            }
          }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[outreachType, emailVerifiedData])

    React.useEffect(() => {
      if(companyReplyId && !replyId){
        dispatch(setReplyId({ replyId: companyReplyId}));
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[companyReplyId])


 
//  function to handle email switch
    const handleSwitchEmail = React.useCallback(()=> {
      triggerEmailRefetch()
      .unwrap()
      .then((res: any)=> {
        if(res.redirectURL){
          window.open(res.redirectURL);
        }
        else if(res.email) {
          if(!disableReplyId){
            dispatch(setSenderId({ senderId: res.email })); 
            setSenderEmail(res.email);
            dispatch(setReplyId({ replyId: res.email}));
            setDisableReplyId(true);
                setToastValue({
                    isToastShown: true,
                    toastMessage: 'As you have used your personal email ID, now you won’t be able to trigger the ‘Blast Campaign’.',
                    toastKey: 'blast-disable',
                    toastSeverity: 'custom',
                    action: <Button
                        color="primary"
                        size="small"
                        variant="outlined"
                        sx={{ textTransform: 'capitalize' }}
                        onClick={() => {
                            setToastValue({
                                isToastShown: false,
                                toastMessage: '',
                                toastKey: '',
                                toastSeverity: 'success',
                            })
                        }}>
                        Ok, got it
                    </Button>
                })
          }
          else{
            dispatch(setSenderId({ senderId: 'opportunities@foundit.in' }));
            if(url && !url.includes('in')){
              let domain = url.split('.').slice(-2).join('.');
              setSenderEmail( `opportunities@${domain}`);
            }
            else{
              setSenderEmail('opportunities@foundit.in');
            }
            dispatch(setReplyId({ replyId: ''}));
            setDisableReplyId(false);
            dispatch(setDisableBlast(false));
          }
        }
      })
      .catch((err) => {
        setToastValue({
          isToastShown: true,
          toastMessage: err.message ? err.message : 'Error while switching email',
          toastKey: 'switch-email-error',
          toastSeverity: 'error'
        })
      })
    },[disableReplyId, dispatch, setToastValue, triggerEmailRefetch, url])

    const handleSenderDetailsChange = (newValue: string) => {
        dispatch(setReplyId({ replyId: newValue }));
        if (errorMessages.replyId) {
            dispatch(setErrorMessages({ errorMessages: { replyId: '' } }));
        }
    }



    return (
        <Stack rowGap={'1rem'}>
            <Stack rowGap='0.3rem'>
                <Label
                    colorType="light"
                    label="Sender ID"
                    labelFor="sender-id"
                    required
                />
              {/* <Tooltip placement="top" title={ outreachType === 'BLAST' ? <div style={{fontSize: '14px'}}>Personal mail ID cannot be used to send blast campaigns. </div> : ''}> */}
              <span>
                <TextBox
                    id="sender-id"
                    textValue={senderEmail}
                    disabled
                    icon={outreachType === 'BLAST'}
                />
                </span>
              {/* </Tooltip> */}
            </Stack>
            {(!hideSwitch && outreachType === 'SCHEDULED') && (<Stack columnGap='0.5rem' direction='row' alignItems={'center'}>
                {SWITCH_ICON}
                <SwitchEmail onClick={handleSwitchEmail}>
                  Switch Email
                </SwitchEmail>
             {isGmailUser ? <Gmail height="30"/> : null}
            </Stack>)} 
            <StyledReplyToStack rowGap='0.3rem'>
              <Box sx={{display:"flex", gap:"12px", alignItems:"center"}}>
                <Label
                    colorType="light"
                    label="Receiver ID"
                    labelFor="reply-id"
                    required={true}
                /> 

                <CommonTooltip title={"Candidate replies will be sent to the receiver ID"} offset={[120,0]} >
                  <Box sx={{display:"flex", alignItems:"center"}}><INFO_ICON height={14} width={14}/></Box>
                </CommonTooltip>
              
              </Box>
                <TextBox
                    id='reply-id'
                    textValue={replyId}
                    handleChange={(e) => handleSenderDetailsChange(e.target.value)}
                    showError={Boolean(errorMessages.replyId)}
                    errorMessage={errorMessages.replyId}
                    disabled={disableReplyId}
                />
            </StyledReplyToStack>
        </Stack>
    )
}

export default SenderDetails;
